import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiGift, FiArrowRight, FiMessageCircle } = FiIcons;

const Coupons = () => {
  const coupons = [
    {
      code: 'UNIPET15',
      discount: '15% OFF',
      description: 'Válido para o primeiro serviço de Banho e Tosa na unidade Centro.',
      validity: 'Disponível por tempo limitado',
      link: 'https://wa.me/5532999857587'
    }
  ];

  return (
    <div className="min-h-screen bg-gray-50 py-16">
      <div className="max-w-4xl mx-auto px-4">
        <header className="text-center mb-12">
          <h1 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4">
            Cupons de Desconto <span className="text-blue-900">UniPET JF</span>
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Aproveite nossas ofertas exclusivas para o bem-estar do seu pet.
          </p>
        </header>

        <section className="bg-white rounded-[32px] p-8 md:p-12 mb-12 shadow-sm border border-gray-100">
          <div className="space-y-8">
            <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-r-2xl">
              <h2 className="text-xl font-bold text-orange-900 mb-2">⚠️ Como aplicar seu cupom?</h2>
              <p className="text-orange-800 leading-relaxed font-medium">
                Para garantir seu desconto, você <b>deve chamar nossa equipe no WhatsApp</b> (32) 99985-7587 ao solicitar seu horário e informar o código do cupom. O desconto será aplicado no fechamento do seu atendimento.
              </p>
            </div>
          </div>
        </section>

        <div className="bg-white rounded-[40px] shadow-2xl shadow-blue-900/5 border border-gray-100 overflow-hidden">
          <div className="grid grid-cols-1 divide-y divide-gray-100">
            {coupons.map((c) => (
              <div key={c.code} className="p-10 flex flex-col md:flex-row items-center justify-between gap-8 hover:bg-blue-50/30 transition-all">
                <div className="text-center md:text-left">
                  <div className="inline-block bg-orange-100 text-orange-600 font-mono font-black text-2xl px-6 py-2 rounded-2xl border border-orange-200 mb-4">
                    {c.code}
                  </div>
                  <h3 className="text-3xl font-black text-gray-900">{c.discount}</h3>
                  <p className="text-gray-500 mt-2 font-medium">{c.description}</p>
                </div>
                <div className="flex flex-col items-center md:items-end">
                  <span className="text-xs font-black text-orange-600 uppercase tracking-widest mb-6 bg-orange-50 px-4 py-2 rounded-full border border-orange-100">
                    {c.validity}
                  </span>
                  <a href={c.link} target="_blank" rel="noopener noreferrer" className="bg-green-500 text-white px-10 py-4 rounded-2xl font-bold flex items-center gap-2 hover:bg-green-600 transition-all shadow-xl shadow-green-900/20">
                    <SafeIcon icon={FiMessageCircle} /> Validar no WhatsApp
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Coupons;